import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';

export default function Navbar(props) {
  
  
  return (
    <>
    <nav className="navbar sticky-top" style={props.myStyle}>
      <div className="container-fluid">
        <div className="buttons">
        <Link className="navbar-brand" to="/" style={props.myStyle}>{props.title}</Link>
        <Link classname="navbar-brand about" id='linkAbout' to="/about" style={props.myStyle}>About</Link>
        </div>
        {/* <div className="custom-control custom-switch"> */}
      <div className="form-check form-switch">
       <input className="form-check-input" type="checkbox" role="switch" aria-checked="false" id="flexSwitchCheckDefault" onClick={props.toggleMode} />
        <label className="form-check-label dark" htmlFor="flexSwitchCheckDefault">dark</label>
      </div>
    </div>
  {/* </div> */}
</nav>
</>
  )
}
Navbar.defaultProps={
  title:"Add Title",
}
Navbar.propTypes = {
  title: PropTypes.string.isRequired
};